var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"x-logo"},[_c('nuxt-resource',{attrs:{"alt":"Dundle logo","src":"images/themes/logos/dundle.com-2023/dundle-logo-light-theme-default.svg"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }